import * as React from 'react'
import {Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {globals} from '../../../extensions/globals-base'
import {Project} from '../../../extensions/project'
import {Board} from '../../../extensions/board'
import {SingleSelect} from '../select/single-select'
import {Option} from '../select/select'
import {Lang} from 'yougile-lang'

interface TreeItem {
  type: 'project' | 'board' | 'column'
  id: DataObjectId
  location: DataObjectId
  title: string
}

interface Props {
  location: DataObjectId
  update: (newLoc: DataObjectId) => void
  className?: string
  onlyColumns?: boolean
}

interface InnerProps {
  tree: Map<DataObjectId, TreeItem>
}

const LocationChooserBase = (props: Props & InnerProps) => {
  const {tree, location, className, update, onlyColumns = false} = props
  const bem = Util.bemFrom('location-chooser', [className])
  const toOpt = (t: TreeItem): Option<DataObjectId> => ({
    label: t.title,
    value: t.id
  })
  const currColumn = tree.get(location)
  const currBoard = tree.get(currColumn?.location)
  const currProject = tree.get(currBoard?.location)

  if (!currProject) {
    return null
  }
  const projects = [...tree.values()].filter(t => t.type === 'project')
  const boards = [...tree.values()].filter(t => t.location === currProject.id)
  const columns = [...tree.values()].filter(t => t.location === currBoard.id)

  const upBoard = (newBoardId: DataObjectId) => {
    const col = [...tree.values()].find(v => v.location === newBoardId)
    update(col?.id)
  }
  const upProj = (newProjId: DataObjectId) => {
    const board = [...tree.values()].find(v => v.location === newProjId)
    upBoard(board?.id)
  }

  return (
    <div className={bem()}>
      {!onlyColumns && (
        <>
          <div className={bem('item')}>
            <div className={bem('item-name')}>{Lang.msg.common.project}:</div>
            <SingleSelect
              className={bem('select')}
              options={projects.map(toOpt)}
              value={currProject.id}
              onChange={upProj}
            />
          </div>
          <div className={bem('item')}>
            <div className={bem('item-name')}>{Lang.msg.common.board}:</div>
            <SingleSelect
              className={bem('select')}
              options={boards.map(toOpt)}
              value={currBoard.id}
              onChange={upBoard}
            />
          </div>
        </>
      )}

      <div className={bem('item')}>
        <div className={bem('item-name')}>{Lang.msg.common.location}:</div>
        <SingleSelect
          className={bem('select')}
          options={columns.map(toOpt)}
          value={currColumn.id}
          onChange={update}
        />
      </div>
    </div>
  )
}

export const LocationChooser = (props: Props) => {
  const companyId = globals.getCompanyId()
  const tree: Map<DataObjectId, TreeItem> = new Map()
  const addToTree = (h: Hub, type: 'project' | 'board' | 'column') => {
    tree.set(h.id, {id: h.id, location: h.location, title: h.title, type})
  }
  Project.listProjects(companyId, 'not-archive')
    .sort(Project.projectOrderComparer)
    .forEach(p => {
      addToTree(p, 'project')
      Project.listBoards(p, true).forEach(b => {
        addToTree(b, 'board')
        Board.listColumns(b, {sorted: true, noMirrors: true}).forEach(col => {
          addToTree(col, 'column')
        })
      })
    })
  return <LocationChooserBase {...props} tree={tree} />
}
